import ServiceCard from './ServiceCard';
import ServicesArchitecture from './ServicesArchitecture';
import { SERVICES } from '../constants/services';

// Import brand logos
import ethereumLogo from '../assets/logos-brands/ethereum-logo.svg';
import figmaLogo from '../assets/logos-brands/figma-line.svg';
import claudeLogo from '../assets/logos-brands/claude-line.svg';
import anthropicLogo from '../assets/logos-brands/anthropic-line.svg';
import googleLogo from '../assets/logos-brands/google-logo.svg';
import hubspotLogo from '../assets/logos-brands/hubspot-crm-logo.svg';
import n8nLogo from '../assets/logos-brands/n8n_full_black_logo.png';
import githubLogo from '../assets/logos-brands/github-logo.svg';
import htmlLogo from '../assets/logos-brands/html-logo.svg';
import databaseLogo from '../assets/logos-brands/database-logo.svg';
import googleAnalyticsLogo from '../assets/logos-brands/google-analytics.svg';
import blockchainLogo from '../assets/logos-brands/blockchain-icon.svg';
import copilotLogo from '../assets/logos-brands/copilot-microsoft-azure.svg';
import bitcoinLogo from '../assets/logos-brands/bit-coin-fill.svg';
import quanturamaLogo from '../assets/logos-brands/quanturama-01010001.svg';

const Services = () => {
  const techLogos = [
    { src: ethereumLogo, alt: 'Ethereum', name: 'ETHEREUM' },
    { src: figmaLogo, alt: 'Figma', name: 'FIGMA' },
    { src: claudeLogo, alt: 'Claude AI', name: 'CLAUDE' },
    { src: anthropicLogo, alt: 'Anthropic', name: 'ANTHROPIC' },
    { src: googleLogo, alt: 'Google', name: 'GOOGLE' },
    { src: hubspotLogo, alt: 'HubSpot CRM', name: 'HUBSPOT' },
    { src: n8nLogo, alt: 'n8n Automation', name: 'N8N' },
    { src: githubLogo, alt: 'GitHub', name: 'GITHUB' },
    { src: htmlLogo, alt: 'HTML5', name: 'HTML5' },
    { src: databaseLogo, alt: 'Database', name: 'DATABASE' },
    { src: googleAnalyticsLogo, alt: 'Google Analytics', name: 'ANALYTICS' },
    { src: blockchainLogo, alt: 'Blockchain', name: 'BLOCKCHAIN' },
    { src: copilotLogo, alt: 'Microsoft Copilot', name: 'COPILOT' },
    { src: bitcoinLogo, alt: 'Bitcoin', name: 'BITCOIN' },
    { src: quanturamaLogo, alt: 'Quanturama', name: 'QUANTURAMA' }
  ];

  return (
    <section className="services-section" id="services">
      <div className="section-header">
        <p className="section-eyebrow">What We Build</p>
        <h2 className="section-title">Four services. <span className="gradient-text">One team.</span></h2>
        <p className="section-subtitle">Every engagement is scoped, built, and shipped — not outsourced or templated.</p>
      </div>

      <div className="services-grid">
        {SERVICES.map((service, index) => (
          <ServiceCard
            key={service.id}
            service={service}
            index={index}
          />
        ))}
      </div>

      <ServicesArchitecture />

      <div className="tech-banner">
        <div className="tech-banner-label">POWERED BY</div>
        <div className="tech-logos">
          {techLogos.map((logo, index) => (
            <div key={index} className="tech-logo">
              <img src={logo.src} alt={logo.alt} />
              <span>{logo.name}</span>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default Services;
